import * as Yup from 'yup';

export const SignupSchema = Yup.object().shape({
    countryDialingCode: Yup.string()
        .required('Please select a dailing code for your phone number'),
    phoneNumber: Yup.string()
        .required('Please enter a phone number')
        .min(6, 'A phone number should be at least 6 digits')
        .max(13, 'A phone number should not be more than 12 digits'),
    email: Yup.string()
        .email("Please enter a valid email address")
        .required('Please enter a valid email address'),
    username: Yup.string()
        .required('Please enter a username')
        .min(8, 'A username should be at least 8 characters')
        .max(24, 'A username should not be more than 24 characters'),
    password: Yup.string()
        .required('Please enter a password'),
    confirmPassword: Yup.string()
        .test('passwords-match', 'Passwords must match', function (value) {
            return this.parent.password === value
        }),
    onboardingQuestionAnswer: Yup.string()
        .required('Please select an answer to the question')
});

export const LoginSchema = Yup.object().shape({
    username: Yup.string().required("Please enter a username"),
    password: Yup.string().required("Please enter a password"),
  });

  export const createOddSchema = Yup.object().shape({
    originBookie: Yup.string().required(),
    "bookingCode": Yup.string().required("Required").min(5, "BookingCode must be longer than or equal to 5 characters"),
    "bookingCodeType": Yup.string().optional(),
    "totalOdds": Yup.string().required("Enter total odds"),
    "firstMatchDate": Yup.string().required("Required"),
    "firstMatchTime": Yup.string().required("Required"),
    "price": Yup.string().optional(),
    potentialWinnings: Yup.string().optional(),
    potentialStake: Yup.string().optional(),
    bookingCodeScreenshots: Yup.mixed().required('Files are required')
})